/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Helper imports
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import AfterSaveGroupModal from "../Modals/AfterSaveGroupModal";
import { groupDetailsHeaderLinks } from "helper/GroupHelper/GroupHelper";
import { ecosystemSlug } from "Config/Config";
import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import GroupDetailsView from "../GroupDetailsView/GroupDetailsView";
import GroupForm from "../GroupForm/GroupForm";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { getMemberOptions } from "helper/ContactHelper/ContactHelper";

const GroupInfoBody = () => {
  const { t } = useTranslation();
  const params = useParams();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess") || "";
  const dateOfToday = new Date().toISOString().split("T")[0];

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("Group"), link: "/admin/group/list" },
    { title: t("Group Info") },
  ];

  // -------- tabs header object --------------------
  const commonHeaderObject = groupDetailsHeaderLinks(params.id, t);

  /**
   * State to manage loading status for data fetches.
   * @type {boolean}
   */
  const [isLoading, setIsLoading] = useState(false);

  // State management
  const [groupData, setGroupField] = useState({
    title: "",
    summary: "",
    details: "",
    objective: "",
    location: "",
    company: null,
    zipcode: "",
    city: "",
    state: "",
    country: "",
    latitude: "",
    longitude: "",
    budget: "",
    category: null,
    searching: null,
    interest: null,
    isPrivate: false,
    autoAccept: false,
    image: "",
    imageId: null,
    documents: [],
    documentIds: [],
    validation: { title: false },
    error: "",
    isUploadingImage: false,
    isUploadingDocs: false,
    isSaving: false,
  });

  const [companyList, setCompanyList] = useState([]);
  const [companyInput, setCompanyInput] = useState("");
  const [categoryList, setcategoryList] = useState([]);
  const [searchingList, setsearchingList] = useState([]);
  const [interestList, setinterestList] = useState([]);
  const [followersInput, setFollowersInput] = useState("");
  const [followersOptions, setFollowersOptions] = useState([]);
  const [isGroupModerator, setIsGroupModerator] = useState(false);
  const [memberStatus, setMemberStatus] = useState({});

  const [savedGroupId, setSavedGroupId] = useState(null);

  /**
   * State to track if initial parameters (event types, categories, etc.) have been fetched.
   * @type {boolean}
   */
  const [isParamsFetched, setIsParamsFetched] = useState(false);

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // function for validate form
  const validateForm = () => {
    const isValid = !!groupData.title.trim();
    setGroupField((prev) => ({
      ...prev,
      validation: { ...prev.validation, title: !isValid },
    }));
    return isValid;
  };

  //function for get all category
  const getAllCategoryList = async () => {
    try {
      const parentSlug = "GROUP";
      const response = await getAllCategories(ecosystemSlug, parentSlug);

      if (response) {
        setcategoryList(response);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllSearchings = async () => {
    try {
      const parentSlug = "searchings";
      const response = await getAllCategories(ecosystemSlug, parentSlug);

      if (response) {
        setsearchingList(response);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllInterests = async () => {
    try {
      const parentSlug = "interests";
      const response = await getAllCategories(ecosystemSlug, parentSlug);

      if (response) {
        setinterestList(response);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getFollowersList = async () => {
    try {
      const data = await getMemberOptions(followersInput);

      setFollowersOptions(data);
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all companies
  const getCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?filtername=${companyInput}&modulefrom=backend`;

      console.log("url of company------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in company------>", response);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  /* function to fetch location from zip code */
  const getLocationFromZip = async () => {
    if (!groupData.zipcode) return;

    try {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${groupData.zipcode}&region=es&key=AIzaSyDt4dbtdHCHLj8grTzTVxpztvqUGDkvkaI`;
      const response = await getData(url);

      if (response.status === "OK" && response.results.length > 0) {
        const address = response.results[0];
        const components = address.address_components.reduce((acc, comp) => {
          comp.types.forEach((type) => {
            acc[type] = comp.long_name;
          });
          return acc;
        }, {});

        setGroupField((prev) => ({
          ...prev,
          city: components.locality || prev.city,
          state: components.administrative_area_level_1 || prev.state,
          country: components.country || prev.country,
          latitude: address.geometry.location.lat,
          longitude: address.geometry.location.lng,
        }));
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  const handleImageUpload = async (files) => {
    if (!files || !files[0]) return;

    setGroupField((prev) => ({ ...prev, isUploadingImage: true }));
    try {
      const apiUrl = `${url.API_BASE_URL}${url.API_SINGLE_FILE_UPLOAD}`;
      const response = await uploadSingleFile(apiUrl, files[0]);

      if (response.status) {
        setGroupField((prev) => ({
          ...prev,
          image: response.data.path,
          imageId: response.data._id,
          isUploadingImage: false,
        }));
      }
    } catch (error) {
      console.error("Image upload error:", error);
      setGroupField((prev) => ({ ...prev, isUploadingImage: false }));
    }
  };

  const handleDocumentUpload = async (files) => {
    if (!files || files.length === 0) return;

    setGroupField((prev) => ({ ...prev, isUploadingDocs: true }));
    try {
      const apiUrl = `${url.API_BASE_URL}${url.API_MULTIPLE_FILE_UPLOAD}`;
      const response = await uploadMultipleFile(apiUrl, files);

      if (response.status) {
        const newFiles = response.data.map((file) => ({
          ...file,
          path: url.SERVER_URL + file.path,
        }));

        setGroupField((prev) => ({
          ...prev,
          documents: [...prev.documents, ...newFiles],
          documentIds: [
            ...prev.documentIds,
            ...response.data.map((f) => ({ _id: f._id })),
          ],
          isUploadingDocs: false,
        }));
      }
    } catch (error) {
      console.error("Document upload error:", error);
      setGroupField((prev) => ({ ...prev, isUploadingDocs: false }));
    }
  };

  const saveGroupHandler = async () => {
    if (!validateForm()) {
      setGroupField((prev) => ({
        ...prev,
        error: t("Please fill required fields"),
      }));
      window.scrollTo(0, 0);
      return;
    }

    setGroupField((prev) => ({ ...prev, isSaving: true, error: "" }));

    const payload = {
      createdate: dateOfToday,
      title: groupData.title,
      summary: groupData.summary,
      description: groupData.details,
      objective: groupData.objective,
      address: groupData.location,
      city: groupData.city,
      state: groupData.state,
      zipcode: groupData.zipcode,
      country: groupData.country,
      latitude: groupData.latitude,
      longitude: groupData.longitude,
      budget: groupData.budget,
      logoid: groupData.imageId,
      uploads: groupData.documentIds,
      categories: groupData.category?.map((c) => c.value) || [],
      searchings: groupData.searching?.map((s) => s.value) || [],
      interests: groupData.interest?.map((i) => i.value) || [],
      followers: groupData.followers?.map((f) => f.value) || [],
      autoapproval: groupData.autoAccept,
      isprivate: groupData.isPrivate,
      companyid: groupData.company?.value || null,
    };

    try {
      const baseUrl = url.API_BASE_URL;
      const endpoint = params.id
        ? `${baseUrl}${url.API_UPDATE_GROUP}/${params.id}`
        : `${baseUrl}${url.API_CREATE_GROUP}`;

      const method = params.id ? putData : postData;
      const response = await method(endpoint, payload);

      // console.log("response in save group---->", response);

      if (response.status) {
        setSavedGroupId(response.data._id);
        setMessageType("success");
        const modal = new window.bootstrap.Modal(
          document.getElementById("saveGroupModal")
        );
        modal.show();
        setGroupField((prev) => ({ ...prev, isSaving: false }));
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setGroupField((prev) => ({ ...prev, isSaving: false }));
    }
    setShowAlert(true);
  };

  //function for get group details
  const getgroupDetails = async () => {
    try {
      setIsLoading(true);
      const apiUrl = `${url.API_BASE_URL}${url.API_GET_GROUP_DETAILS}/${params.id}?modulefrom=backend`;
      const response = await getData(apiUrl);
      setIsLoading(false);

      if (response.status) {
        setMessageType("success");
        const { data } = response;
        setGroupField((prev) => ({
          ...prev,
          title: data.title || "",
          summary: data.summary || "",
          details: data.description || "",
          objective: data.objective || "",
          location: data.address || "",
          company: data.selectedcompany || null,
          zipcode: data.zipcode || "",
          city: data.city || "",
          state: data.state || "",
          country: data.country || "",
          latitude: data.latitude || "",
          longitude: data.longitude || "",
          budget: data.budget || "",
          category: data.groupcategories || null,
          searching: data.groupsearchings || null,
          interest: data.groupinterests || null,
          followers: data.groupfollowers || null,
          isPrivate: data.isprivate || false,
          autoAccept: data.autoapproval || false,
          image: data.grouplogoimage || "",
          imageId: data.grouplogoid || null,
          documents:
            data.uploads?.map((file) => ({
              ...file,
              path: url.SERVER_URL + file.path,
            })) || [],
          documentIds: data.uploadedfileids || [],
        }));

        const isModerator =
          data.moderator?.toString() === userInfo._id?.toString() ||
          ["ADMIN", "SUPER_ADMIN"].includes(userInfo.role?.slug);

        setIsGroupModerator(isModerator);
        if (!isModerator) getMemberDetails();
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for get details of event member
  const getMemberDetails = async () => {
    try {
      const apiUrl = `${url.API_BASE_URL}${url.API_GET_GROUP_MEMBER_DETAILS_BY_QUERY}?groupid=${params.id}`;
      const response = await getData(apiUrl);
      // console.log("response in member details", response);
      if (response.status) {
        setMemberStatus({
          id: response.data._id,
          status: response.data.memberstatus,
          modStatus: response.data.moderatorstatus,
          inviteDate: response.data.requestdate,
          joinDate: response.data.joindate,
        });
      }
    } catch (error) {
      console.error("Error fetching member details:", error);
    }
  };

  //function for close afterSavegroupModal
  const afterSavegroupModalClose = (actionType = "list") => {
    if (actionType == "list") {
      history.push("/admin/group/list");
    } else {
      history.push(`/admin/group/info/${savedGroupId}`);
    }
  };

  useEffect(() => {
    if (params.id) {
      getgroupDetails();
    }
  }, [params.id]);

  useEffect(() => {
    const fetchAllParams = async () => {
      await Promise.all([
        getAllCategoryList(),
        getAllSearchings(),
        getAllInterests(),
      ]);
      setIsParamsFetched(true);
    };
    fetchAllParams();
  }, []);

  useEffect(() => {
    if (companyInput.length > 1) {
      getCompanyList();
    }
  }, [companyInput]);

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersList();
    }
  }, [followersInput]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // Render condition
  if (
    !["ADMIN", "SUPER_ADMIN"].includes(userInfo.role?.slug) &&
    !moduleAccess.includes("MOD_GROUP")
  ) {
    return <AccessDeniedView />;
  }

  /**
   * Conditional rendering: If initial parameters are still being fetched or
   * event details are loading, display a placeholder loading view.
   */
  if (!isParamsFetched || isLoading) {
    return (
      <div id="content_wrapper">
        {" "}
        <section className="event-details-wrapper bg-white pb-5">
          {" "}
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {" "}
            <div className="py-5">
              <div className="placeholder-glow">
                <span
                  className="placeholder col-12 mb-3"
                  style={{ height: 40, display: "block" }}
                ></span>
                <span
                  className="placeholder col-8 mb-3"
                  style={{ height: 30, display: "block" }}
                ></span>
                <span
                  className="placeholder col-6 mb-3"
                  style={{ height: 30, display: "block" }}
                ></span>
                <span
                  className="placeholder col-4 mb-3"
                  style={{ height: 30, display: "block" }}
                ></span>
                <span
                  className="placeholder col-12 mb-3"
                  style={{ height: 200, display: "block" }}
                ></span>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div id="content_wrapper">
      <section className="group-details-wrapper bg-white pb-5">
        {params.id && (
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Group Info")}
          />
        )}

        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          <BreadCrumb
            breadCrumbText={breadcrumbText}
            bottom={true}
            displayName={`${groupData.title}`}
          />

          {params.id && !isGroupModerator ? (
            <GroupDetailsView
              groupData={groupData}
              memberStatus={memberStatus}
              t={t}
            />
          ) : (
            <GroupForm
              groupData={groupData}
              setGroupField={(field) => (value) =>
                setGroupField((prev) => ({ ...prev, [field]: value }))}
              handleLocationFromZip={getLocationFromZip}
              handleImageUpload={handleImageUpload}
              handleDocumentUpload={handleDocumentUpload}
              handleSubmit={saveGroupHandler}
              categoryList={categoryList}
              searchingList={searchingList}
              interestList={interestList}
              companyList={companyList}
              followersOptions={followersOptions}
              setCompanyInput={setCompanyInput}
              setFollowersInput={setFollowersInput}
              t={t}
              isSaving={groupData.isSaving}
            />
          )}

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </div>
      </section>
      <AfterSaveGroupModal afterSaveModalClose={afterSavegroupModalClose} />
    </div>
  );
};

export default GroupInfoBody;
